import useAxios from '../hooks/useAxios';
import {ACTIVITY_CLICK_URL} from './constants';

/**
 * Hook for interacting with the Activity Click API (needed for dashboard symptom checker history).
 *
 * @returns {Object} An object containing functions to interact with the API.
 */
export const useActivityClickApi = () => {
  const api = useAxios();

  /**
   * Posts an activity click event to the server.
   *
   * @param {string} buttonName - The name of the button that was clicked.
   * @returns {Promise} A Promise that resolves when the request is complete.
   */
  const postActivityClick = buttonName =>
    api.post(ACTIVITY_CLICK_URL, null, {
      params: {
        object_name: buttonName,
      },
    });

  return {
    postActivityClick,
  };
};
